export default function autenticacaoReducer(state = '', action) {
    if( action.type === 'LOGIN_SUCCESS' ) {
        return action.nomeUsuario;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/redux/reducers/autenticacaoReducer.js